import React from "react";
import { Alert } from "components/Shared/Alerts";
import { Modal } from "components/Shared/Modal";

import { closeAlert, setIsOpenUseEDUBAModal } from "redux/reducers/appSlice";

import useAppSelectors from "redux/selectors/appSelectors";
import { useAppDispatch } from "redux/store/hooks";
import RegSteps from "view/StaticPages/RegSteps";
import { Button } from "components/Shared/Button";
import { useHistory } from "react-router-dom";
import RoutePaths from "routes/RoutePaths";

const AlertHooks = () => {
  const { alert, isOpenUseEDUBAModal } = useAppSelectors();
  const dispatch = useAppDispatch();
  const { push } = useHistory();

  const handleAlertClose = () => {
    dispatch(closeAlert());
  };

  return (
    <>
      {alert?.isOpen && (
        <Alert
          id="app-alert"
          type={alert?.type}
          isOpen={alert?.isOpen}
          handleClose={handleAlertClose}
        >
          {alert?.children}
        </Alert>
      )}
      {isOpenUseEDUBAModal && (
        <Modal
          id="how-to-use-eduba-modal"
          open={isOpenUseEDUBAModal}
          handleClose={() => {
            dispatch(setIsOpenUseEDUBAModal(false));
          }}
        >
          <div className="modal-content">
            <div className="modal-title">EDUBAの使い方</div>
            <div className="modal-sub-title">
              EDUBAは3ステップで簡単に使い始めることができます。
            </div>
            <RegSteps />
            <Button
              customStyles="btn-link"
              variant="text"
              label="使い方ガイドはこちら"
              onClick={() => {
                push(RoutePaths.howToUseGuide);
                dispatch(setIsOpenUseEDUBAModal(false));
                document.location.reload();
              }}
            />
          </div>
        </Modal>
      )}
    </>
  );
};

export default AlertHooks;
